import { useCallback, useContext } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';

import { AjaxContext, AppContext, formatListData, UserContext } from 'commons-ui';
import { UserDetailsContext } from '../../../context/userDetails';
import { ACTION } from '../../../constant';
import { EURL } from '../../../enum';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const { permissionsConfig } = useContext(UserContext);
	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);

	const {
		app: { appName }
	} = useContext(AppContext);
	const getReferralsData = useCallback(async ({ pageDetails }) => {
		const permission = _find(permissionsConfig, { actionName: ACTION.getReferralsSummary });
		const result = await postData({
			endpoint: EURL.GET_REFERRALS_SUMMARY,
			queryParams: {
				appName
			},
			body: {
				uid,
				pageNumber: pageDetails.pageNo
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});

		const data = _get(result, ['data', 'data'], {});
		const referalData = _get(data, 'referralsSummary', []);
		const listData = await formatListData(referalData);
		const rowCount = _get(data, ['totalRecordCount'], 0);

		return { rowCount, data: listData };
	}, []);

	return { getReferralsData };
};

export default useService;
